import { mapActions } from 'vuex'

export default {

  computed:{

    siteInfo:function(){
      return this.$store.state.siteInfo
    },

    infoLoaded:function(){
      return this.$store.state.siteInfoLoaded
    },

    contactEmail(){
      if(this.$store.state.siteInfo == null) return "";
      return String.fromCharCode.apply(null, this.$store.state.siteInfo['contact-email'])
    }
  },

  methods:{
    ...mapActions(['requestSiteInfo']),

    async getSiteInfo(){
      return await this.requestSiteInfo().then((/*data*/)=>{
        this.siteInfoLoaded = true
        // console.log(data)
      })
    },
  }
}